import React from 'react';

// One card template for every AI Projects entry, so the grid reads as a set:
// a thin browser-chrome bar over a single screenshot on a soft gray panel,
// then a title and year row, a one-line description, and a View Website link.
// The screenshot is cropped to a fixed 16:10 frame so every card is the same
// height regardless of the source image.
const AIProjectCard = ({
  title,
  year,
  description,
  href,
  hero,
  heroAlt,
  heroPosition = 'top left',
}) => (
  <div className="group flex flex-col h-full bg-white rounded-[28px] p-5 sm:p-6 shadow-[0_1px_2px_rgba(0,0,0,0.04)] transition-shadow duration-300 hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)]">
    <div className="rounded-2xl bg-canvas p-4 sm:p-6">
      <div className="rounded-lg overflow-hidden bg-white shadow-md transition-transform duration-500 ease-out group-hover:-translate-y-1">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border-b border-gray-light" aria-hidden="true">
          <span className="w-2 h-2 rounded-full bg-gray-300" />
          <span className="w-2 h-2 rounded-full bg-gray-300" />
          <span className="w-2 h-2 rounded-full bg-gray-300" />
        </div>
        <img
          src={hero}
          alt={heroAlt}
          className="w-full aspect-[16/10] object-cover block"
          style={{ objectPosition: heroPosition }}
        />
      </div>
    </div>
    <div className="mt-6 px-1 flex flex-col flex-1">
      <div className="flex justify-between items-baseline gap-4">
        <h3 className="text-2xl font-bold tracking-tight text-ink">{title}</h3>
        <p className="text-sm text-muted whitespace-nowrap">Created in {year}</p>
      </div>
      <p className="mt-2 text-[15px] leading-relaxed text-muted">{description}</p>
      <div className="mt-auto pt-5">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-medium text-secondary hover:underline"
        >
          Try it out ↗
        </a>
      </div>
    </div>
  </div>
);

export default AIProjectCard;
